import Constants from "../../utils/CommonConstants";
import StoreAdminCartController from "./controllers/StoreAdminCartController";

const routes = [
    {
        name: Constants.RoutingStates.CART,
        url: "/cart",
        windowTitle: 'client.cart.group',
        views: {
            contents: {
                template: require('./views/cartView.pug'),
                controller: 'Cartonomy.Cart.CartController'
            }
        }
    },
    {
        name: Constants.RoutingStates.START_CHECKOUT,
        url: "/start_checkout",
        windowTitle: 'client.cart.checkout_start',
        views: {
            contents: {
                template: require('./views/orderStartCheckout.pug'),
                controller: "Cartonomy.Cart.CartController"
            }
        }
    },
    {
        name: Constants.RoutingStates.INVITED_PEOPLE,
        url: "/invitedPeople",
        windowTitle: 'client.members',
        views: {
            contents: {
                template: require('./views/invitedPeopleView.pug'),
                controller: 'Cartonomy.Cart.InvitedPeopleListController'
            }
        }
    },
    {
        name: Constants.RoutingStates.STORE_ADMIN,
        url: "/storeAdmin",
        views: {
            contents: {
                template: require('./views/storeAdmin.pug'),
                controller: StoreAdminCartController.$controllerName
            }
        }
    },
    {
        name: Constants.RoutingStates.OPEN_CARTS,
        url: "/opentCarts",
        windowTitle: 'client.cart.open_cart',
        views: {
            contents: {
                template: require('./views/openCarts.pug'),
                controller: StoreAdminCartController.$controllerName
            }
        }
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/modules/cart/routeConfig.js